import keyBy from "lodash/keyBy";
import * as React from "react";
import { useState } from "react";
import { Datagrid, FunctionField, ListContextProvider } from "react-admin";
import { useAppDataProvider } from "../../dataprovider";
import { EnumField } from "../../../src/Components/EnumField";
import { CustomDateField } from "../../Components/CustomDateField";
import { useHistory } from "react-router-dom";
import { IconButton } from "@material-ui/core";
import { InsertLink } from "@material-ui/icons";

const ReliabilityOtherConditions = goodsRcvdBatch => {
  const dataProvider = useAppDataProvider();
  const [data, setData] = useState([] as any);
  const history = useHistory();

  React.useEffect(() => {
    if (goodsRcvdBatch !== undefined || goodsRcvdBatch !== null) {
      dataProvider.getReliabilityOtherConditions(goodsRcvdBatch.goodsRcvdBatch).then(result => {
        setData(result.data);
      });
    }
  }, []);

  const ButtonRedirect = data => {
    history.push("/" + data.reliabilityLink);
    const win: any = window.open(`#/${data.reliabilityLink}`, "_blank");
  };

  return (
    <ListContextProvider
      value={{
        data: keyBy(data, "id"),
        ids: data.map?.(({ id }) => id),
        currentSort: { field: "id", order: "ASC" },
      }}
    >
      <Datagrid optimized>
        <FunctionField
          label={"LINK"}
          render={(record: any) => (
            <IconButton
              onClick={e => {
                e?.stopPropagation?.();
                ButtonRedirect(record);
              }}
              color="primary"
            >
              <InsertLink />
            </IconButton>
          )}
        />
        <EnumField label={"Report Type"} enumName={"ReliabilityReportType"} source={"reportType"} />
        <CustomDateField source="createdDate" label="Created Date" showTime />
      </Datagrid>
    </ListContextProvider>
  );
};

export default ReliabilityOtherConditions;
